"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
var _reactDndHtml5Backend = require("react-dnd-html5-backend");
var _ItemTypes = require("./ItemTypes.js");
var _SortOption = _interopRequireDefault(require("./SortOption"));
function getStyles(left, top, isDragging) {
  var transform = "translate3d(".concat(left, "px, ").concat(top, "px, 0)");
  return {
    transform: transform,
    WebkitTransform: transform,
    opacity: isDragging ? 0 : 1
  };
}
var DraggableOption = function DraggableOption(props) {
  var completed = props.completed,
    optionName = props.optionName,
    optionK = props.optionK,
    categories = props.categories,
    stateOptions = props.stateOptions,
    optionContainerOnChange = props.optionContainerOnChange,
    left = props.left,
    top = props.top,
    dropdownState = props.dropdownState,
    setDropdownState = props.setDropdownState,
    focusState = props.focusState,
    setFocusState = props.setFocusState,
    isTouchDevice = props.isTouchDevice;
  var _useDrag = (0, _reactDnd.useDrag)(function () {
      var inIframe = window.location !== window.parent.location ? "-iframe" : "";
      return {
        type: _ItemTypes.ItemTypes.OPTION,
        item: {
          name: "answer-option-".concat(optionK) + inIframe,
          optionName: optionName,
          optionK: optionK,
          categories: categories,
          stateOptions: stateOptions,
          optionContainerOnChange: optionContainerOnChange
        },
        end: function end(item, monitor) {
          var dropResult = monitor.getDropResult();
          if (item && dropResult) {
            var categoryID = parseInt(dropResult.name.slice(-1), 10);
            if (stateOptions[optionK].currentCategory === categoryID) {
              return;
            }
            optionContainerOnChange(categoryID, optionK, stateOptions[optionK].currentCategory);
          }
        },
        collect: function collect(monitor) {
          return {
            isDragging: monitor.isDragging()
          };
        },
        canDrag: !completed && !dropdownState
      };
    }, [completed, dropdownState]),
    _useDrag2 = (0, _slicedToArray2.default)(_useDrag, 3),
    isDragging = _useDrag2[0].isDragging,
    drag = _useDrag2[1],
    preview = _useDrag2[2];
  (0, _react.useEffect)(function () {
    preview((0, _reactDndHtml5Backend.getEmptyImage)(), {
      captureDraggingState: true
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: drag,
    style: getStyles(left, top, isDragging),
    id: "answer-option-".concat(optionK)
  }, /*#__PURE__*/_react.default.createElement(_SortOption.default, {
    completed: completed,
    optionName: optionName,
    optionK: optionK,
    categories: categories,
    stateOptions: stateOptions,
    optionContainerOnChange: optionContainerOnChange,
    dropdownState: dropdownState,
    setDropdownState: setDropdownState,
    focusState: focusState,
    setFocusState: setFocusState,
    isTouchDevice: isTouchDevice
  }));
};
var _default = exports.default = DraggableOption;